import React, { useEffect } from 'react';
import { Text } from '@fiverr-private/typography';
import { briefCreationDrawerEducationIsShown } from '../../../../monitoring';
import { useBriefCreationContext } from '../../../../context/BriefCreationContext';
import { AppI18n } from '../../../../i18n';
import { Currency } from '../../../../types/currency';
import { Step } from '../../../../constants';
import { centsToCurrency } from '../utils';

interface BudgetRecommendedEducationProps {
  minimumPrice: number;
  currency: Currency;
}

export const BudgetRecommendedEducation = ({ minimumPrice, currency }: BudgetRecommendedEducationProps) => {
  const { briefClassification, contextId, source, variant, initialStep } = useBriefCreationContext();

  const leafClassification = briefClassification?.leaf_classification[0];

  useEffect(
    () =>
      briefCreationDrawerEducationIsShown({
        educationType: 'recommended_budget',
        minimumPrice,
        categoryId: leafClassification?.category_id,
        subCategoryId: leafClassification?.sub_category_id,
        nestedCategoryId: leafClassification?.nested_sub_category_id,
        briefContextId: contextId,
        eventSource: source || '',
        variant,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const isEditMode = initialStep === Step.Edit;
  const translationKey = isEditMode
    ? 'sections.budget.under_budget_description_edit'
    : 'sections.budget.under_budget_description';

  return (
    <Text size="b_sm">
      <AppI18n k={translationKey} params={{ min: centsToCurrency(minimumPrice, currency) }} />
    </Text>
  );
};
